import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../src/core/api/axiosClientDMS";
import axiosSLP from "../../../src/core/api/axiosClient";
import * as moment from "moment";

const initialState: any = {
  dmsDevices: [],
  dmsDevicesList: [],
  isLoadingDmsDevices: false,
  dmsDeviceList: [],
  isLoadingDmsDeviceList: false,
  filter: {}, //
  alertListOfSingleDevice: [],
  isLoadingAlertListOfSingleDevice: false,
  messageExchangeList: [],
  isLoadingMessageExchangeList: false,
  activityList: [],
  isLoadingActivityList: false,
  dmsDeviceDetails: {},
  isLoadingDmsDeviceDetails: false,
  isLoading: false,
  error: null,
  deviceOnlileOrOfflineStatus: [],
  isLoadingDeviceOnlileOrOfflineStatus: false,
  deviceExport: [],
  isLoadingDeviceExport: false,
};

export const exportDevices: any = createAsyncThunk(
  "content/exportDevices",
  async ({
    tcCode = "",
    siteCode = "",
    blockCode = "",
    isActive = false,
    isOnline = false,
    searchText = "",
    sortBy = "",
    sortDirection = "",
  }: any) => {
    const payload = {
      tcCode,
      siteCode,
      blockCode,
      isActive,
      isOnline,
      searchText,
      sortBy,
      sortDirection,
    };

    try {
      const response = await axios.post(
        `/dmsapp/Device/getDevice/downloadExcel`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
          responseType: "blob",
        }
      );

      let filename = response.headers["content-disposition"]
        ?.split(";")
        ?.find((n: any) => n.includes("filename="))
        ?.replace("filename=", "")
        ?.trim();

      const fileBlob = new Blob([response.data], {
        type: "application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const fileUrl = URL.createObjectURL(fileBlob);

      const link = document.createElement("a");
      link.href = fileUrl;

      link.download = filename;

      link.click();

      URL.revokeObjectURL(fileUrl);

      return response.data;
    } catch (error) {
      console.error("Error downloading fault report:", error);
      throw error;
    }
  }
);

export const getDeviceOnlineOrOffline: any = createAsyncThunk(
  "content/getDeviceOnlineOrOffline",
  async ({ id }: any) => {
    const res = await axiosSLP.get(
      `/slpapp/AssetHealth/CheckAssetOnlineOrOffline`,
      {
        params: { assetCode: id },
      }
    );

    const data = await res.data.data;
    return data;
  }
);

export const getDMSDevices: any = createAsyncThunk(
  "content/getDMSDevices",
  async ({
    PageNumber,
    pageSize,
    tcCode = null,
    siteCode = null,
    blockCode = null,
    isOnline = null,
    isActive = null,
    SortBy,
    SortDirection,
    searchText,
  }: any) => {
    const res = await axios.get(`/dmsapp/Device/DeviceListBySearch`, {
      params: {
        PageNumber,
        pageSize,
        tcCode,
        siteCode,
        blockCode,
        isOnline,
        isActive,
        SortBy,
        SortDirection,
        searchText,
      },
    });
    const data = await res.data;

    return data;
  }
);

export const getDMSDeviceList: any = createAsyncThunk(
  "content/getDMSDeviceList",
  async (params) => {
    const res = await axios.get(`/dmsapp/Device/DeviceListBySearch`, {
      params: params,
    });
    const data = await res.data;

    return data;
  }
);

export const getCertificateDeviceList: any = createAsyncThunk(
  "content/getCertificateDeviceList",
  async (params) => {
    const res = await axios.get(`/dmsapp/Device/GetDeviceList`, {
      params: params,
    });
    const data = await res?.data;

    return data;
  }
);

export const getDMSDeviceById: any = createAsyncThunk(
  "content/getDMSDeviceById",
  async ({ deviceId }: any) => {
    const res = await axios.get(`/dmsapp/Device/GetDeviceDetailsById`, {
      params: { deviceId },
    });

    const data = await res.data?.data;
    return data;
  }
);

export const addDevice: any = createAsyncThunk(
  "content/addDevice",
  async ({ payload }: any) => {
    const payloadData = [payload];
    const res = await axios.post(`/dmsapp/Device`, payloadData, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await res.data;
    return data;
  }
);

export const editDevice: any = createAsyncThunk(
  "content/editDevice",
  async ({ payload, deviceCode }: any) => {
    const res = await axios.put(`/dmsapp/Device`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
      params: { deviceCode },
    });

    const data = await res.data;
    return data;
  }
);

export const deleteDevice: any = createAsyncThunk(
  "content/deleteDevice",
  async ({ id }: any) => {
    const res = await axios.delete(`/dmsapp/Device`, {
      params: { deviceId: id },
    });

    const data = await res.data.data;
    return data;
  }
);

export const getAlertListByDeviceId: any = createAsyncThunk(
  "content/getAlertListByDeviceId",
  async ({ PageNumber, PageSize, StartDate, EndDate, deviceId }: any) => {
    const res = await axios.get(`/dmsapp/Device/GetAlertListByDeviceId`, {
      params: { PageNumber, PageSize, StartDate, EndDate, deviceId },
    });

    let data = await res.data;

    const modifiedData = data?.data.map((data: any, index: number) => {
      return {
        id: index + 1,
        serial: data?.serial,
        activityType: data?.payload,
        timeStamp: data?.slot_data,
        details: `No ${data?.payload} received since ${moment
          .utc(data?.lastresponseacknowledged)
          .local()
          .format("D-MMM-Y HH:mm:ss")}`,
      };
    });

    data.data = modifiedData;
    return data;
  }
);

export const getActivityListByDeviceId: any = createAsyncThunk(
  "content/getActivityListByDeviceId",
  async ({ PageNumber, pageSize, StartDate, EndDate, deviceId }: any) => {
    const res = await axios.get(`/dmsapp/Device/GetAcivityListByDeviceId`, {
      params: { PageNumber, pageSize, StartDate, EndDate, deviceId },
    });

    let data = await res.data;

    const modifiedData = data?.data.map((data: any, index: number) => {
      return {
        id: index + 1,
        serial: data?.serial,
        activityType: data?.activityType,
        timeStamp: data?.timeStamp,
        details: data?.details,
      };
    });

    data.data = modifiedData;
    return data;
  }
);

export const getMessageExchangedList: any = createAsyncThunk(
  "content/getMessageExchangedList",
  async ({ PageNumber, pageSize, StartDate, EndDate, deviceId }: any) => {
    const res = await axios.get(
      `/dmsapp/Device/MessageExchangeListByDeviceId`,
      {
        params: { PageNumber, pageSize, StartDate, EndDate, deviceId },
      }
    );

    let data = await res.data;

    const modifiedData = data?.data.map((data: any, index: number) => {
      return {
        id: index + 1,
        serial: data?.serial,
        alertType: data?.alertType,
        timeStamp: data?.timeStamp,
        details: data?.details,
      };
    });

    data.data = modifiedData;
    return data;
  }
);

export const uploadDevice: any = createAsyncThunk(
  "content/uploadDevice",
  async ({ file }: { file: File }) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await axios.post(
        `/dmsapp/Device/InsertDeviceByFile`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error uploading file:", error);
      throw error;
    }
  }
);

export const getDeviceSampleFile: any = createAsyncThunk(
  "content/getFaultReports",
  async () => {
    try {
      const response = await axios.post(
        `/dmsapp/Device/download/demo`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
          },
          responseType: "blob",
        }
      );

      const fileBlob = new Blob([response.data], {
        type: "application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const fileUrl = URL.createObjectURL(fileBlob);

      const link = document.createElement("a");
      link.href = fileUrl;

      link.download = "DeviceDemo.xlsx";

      link.click();

      URL.revokeObjectURL(fileUrl);

      return response.data;
    } catch (error) {
      console.error("Error downloading fault report:", error);
      throw error;
    }
  }
);

export const dmsDeviceSlice = createSlice({
  name: "dmsDevice",
  initialState,
  reducers: {
    setFilter(state, action) {
      state.filter = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(exportDevices.pending, (state) => {
      state.isLoadingDeviceExport = true;
    });
    builder.addCase(exportDevices.fulfilled, (state, action) => {
      state.isLoadingDeviceExport = false;
      state.assetExport = action.payload;
    });
    builder.addCase(exportDevices.rejected, (state, action) => {
      state.isLoadingDeviceExport = false;
      state.error = action.error.message;
    });

    builder.addCase(getDeviceOnlineOrOffline.pending, (state) => {
      state.isLoadingDeviceOnlileOrOfflineStatus = true;
    });
    builder.addCase(getDeviceOnlineOrOffline.fulfilled, (state, action) => {
      state.isLoadingDeviceOnlileOrOfflineStatus = false;
      state.deviceOnlileOrOfflineStatus = action.payload;
    });
    builder.addCase(getDeviceOnlineOrOffline.rejected, (state, action) => {
      state.isLoadingDeviceOnlileOrOfflineStatus = false;
      state.error = action.error.message;
    });

    builder.addCase(getDMSDevices.pending, (state) => {
      state.isLoadingDmsDevices = true;
    });
    builder.addCase(getDMSDevices.fulfilled, (state, action) => {
      state.isLoadingDmsDevices = false;
      state.dmsDevices = action.payload;
    });
    builder.addCase(getDMSDevices.rejected, (state, action) => {
      state.isLoadingDmsDevices = false;
      state.error = action.error.message;
    });

    builder.addCase(getDMSDeviceList.pending, (state) => {
      state.isLoadingDmsDeviceList = true;
    });
    builder.addCase(getDMSDeviceList.fulfilled, (state, action) => {
      state.isLoadingDmsDeviceList = false;
      state.dmsDevices = action.payload;
    });
    builder.addCase(getDMSDeviceList.rejected, (state, action) => {
      state.isLoadingDmsDeviceList = false;
      state.error = action.error.message;
    });

    builder.addCase(getCertificateDeviceList.pending, (state) => {
      state.isLoadingDmsDeviceList = true;
    });
    builder.addCase(getCertificateDeviceList.fulfilled, (state, action) => {
      state.isLoadingDmsDeviceList = false;
      state.dmsDevicesList = action.payload;
    });
    builder.addCase(getCertificateDeviceList.rejected, (state, action) => {
      state.isLoadingDmsDeviceList = false;
      state.error = action.error.message;
    });

    builder.addCase(getDMSDeviceById.pending, (state) => {
      state.isLoadingDmsDeviceDetails = true;
    });
    builder.addCase(getDMSDeviceById.fulfilled, (state, action) => {
      state.isLoadingDmsDeviceDetails = false;
      state.dmsDeviceDetails = action.payload;
    });
    builder.addCase(getDMSDeviceById.rejected, (state, action) => {
      state.isLoadingDmsDeviceDetails = false;
      state.error = action.error.message;
    });

    builder.addCase(deleteDevice.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(deleteDevice.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(deleteDevice.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(addDevice.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(addDevice.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(addDevice.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(editDevice.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(editDevice.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(editDevice.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(uploadDevice.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(uploadDevice.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(uploadDevice.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(getAlertListByDeviceId.pending, (state) => {
      state.isLoadingAlertListOfSingleDevice = true;
    });
    builder.addCase(getAlertListByDeviceId.fulfilled, (state, action) => {
      state.isLoadingAlertListOfSingleDevice = false;
      state.alertListOfSingleDevice = action.payload;
    });
    builder.addCase(getAlertListByDeviceId.rejected, (state, action) => {
      state.isLoadingAlertListOfSingleDevice = false;
      state.error = action.error.message;
    });

    builder.addCase(getActivityListByDeviceId.pending, (state) => {
      state.isLoadingActivityList = true;
    });
    builder.addCase(getActivityListByDeviceId.fulfilled, (state, action) => {
      state.isLoadingActivityList = false;
      state.activityList = action.payload;
    });
    builder.addCase(getActivityListByDeviceId.rejected, (state, action) => {
      state.isLoadingActivityList = false;
      state.error = action.error.message;
    });

    builder.addCase(getMessageExchangedList.pending, (state) => {
      state.isLoadingMessageExchangeList = true;
    });
    builder.addCase(getMessageExchangedList.fulfilled, (state, action) => {
      state.isLoadingMessageExchangeList = false;
      state.messageExchangeList = action.payload;
    });
    builder.addCase(getMessageExchangedList.rejected, (state, action) => {
      state.isLoadingMessageExchangeList = false;
      state.error = action.error.message;
    });
  },
});

export const { setFilter } = dmsDeviceSlice.actions;

export default dmsDeviceSlice.reducer;
